export default {
  login: {
    title: 'Iniciar sesión',
    usernameLabel: 'Nombre de usuario',
    usernamePlaceholder: '2-10 dígitos en inglés',
    loginPasswordLabel: 'Contraseña de inicio de sesión',
    loginPasswordPlaceholder: 'Ingrese su contraseña de inicio de sesión',
    googleCodeLabel: 'código de verificación de Google',
    googleCodePlaceholder: 'Ingrese un código de verificación de Google de 6 dígitos',
    hasNoAccount: 'Sin cuenta todavía,',
    goRegister: 'Ir a registrarse',
    onlineCustom: 'Servicio al cliente en línea',
    loginArgument: 'Continuar iniciando sesión significa estar de acuerdo',
    userArgument: '《Acuerdo de usuario》',
    registerNotEnabled: 'La función de registro no está abierta, comuníquese con el administrador',
    usernameRequired: 'Ingrese un nombre de usuario correcto',
    loginPasswordRequired: 'Ingrese la contraseña de inicio de sesión correcta',
    googleCodeRequired: 'Ingrese el código de verificación de Google correcto',
    loginButton: 'iniciar sesión'
  },
  register: {
    title: 'Registrar',
    usernameLabel: 'Nombre de usuario',
    usernamePlaceholder: 'Ingrese el nombre de usuario registrado',
    loginPasswordLabel: 'Contraseña de inicio de sesión',
    loginPasswordPlaceholder: 'Ingrese la contraseña de inicio de sesión del usuario registrado',
    loginPasswordPreLabel: 'Confirmar contraseña de inicio de sesión',
    loginPasswordPrePlaceholder: 'Ingrese la contraseña de inicio de sesión nuevamente',
    fudPasswordLabel: 'Contraseña del fondo',
    fudPasswordPlaceholder: 'Ingrese la contraseña del fondo',
    inviteCodeLabel: 'Código de invitación',
    inviteCodePlaceholder: 'Ingrese un código de invitación de 6 dígitos',
    registerNeed: 'Continuar para registrarse significa estar de acuerdo',
    registerArgument: '《Acuerdo de registro》',
    usernameRequired: 'Ingrese un nombre de usuario correcto',
    loginPasswordRequired: 'Ingrese la contraseña de inicio de sesión correcta',
    loginPasswordPreRequired: 'Ingrese la contraseña de inicio de sesión de confirmación correcta',
    fundPasswordRequired: 'Ingrese la contraseña correcta del fondo',
    inviteCodeRequired: 'Ingrese el código de invitación correcto',
    diffLoginPasswordError: 'Las dos contraseñas de inicio de sesión son inconsistentes',
    registerSuccess: 'Registro exitoso',
    registerButton: 'Registrarse',
    emailLabel: 'Correo electrónico',
    emailPlaceholder: 'Ingrese su dirección de correo electrónico',
    emailCodeLabel: 'Código de verificación',
    emailCodePlaceholder: 'Ingrese su código de verificación de correo electrónico',
    second: 'segundo',
    getEmailCodeButton: 'Obtener código',
    emailRequired: 'Ingrese una dirección de correo electrónico correcta y vuelva a intentarlo',
    emailCodeRequired: 'Ingrese el código de verificación de correo electrónico correcto y vuelva a intentarlo'
  },
  home: {
    hotCoin: {
      title: 'Las mejores ofertas',
      more: 'mas'
    },
    poster: {
      title: 'Depósito rápido',
      enter: 'Ingrese ahora>',
      subTitle: 'Soporte BTC, USDT, ETH, etc.'
    },
    quickMenus: {
      futuresTrading: 'Negociación de futuros',
      helpCenter: 'Centro de ayuda'
    },
    ranking: {
      increase: {
        title: 'Lista en ascenso'
      },
      clinch: {
        title: 'Lista de facturación'
      }
    }
  },
  tabBar: {
    home: 'Hogar',
    price: 'Mercado',
    trade: 'Comercio',
    fund: 'Activo',
    user: 'Perfil'
  },
  currency: {
    favorite: 'Opcional',
    allCurrency: 'al contado',
    dayVol: '24H',
    addFavor: '+ Agregar favor'
  },
  trade: {
    bills: 'Facturas',
    todayOpen: 'Abierto',
    star: 'Estrella',
    vol: 'Volumen',
    low: 'Más bajo',
    high: 'Más alto',
    timing: 'rápido',
    spot: 'futuros',
    buyMore: 'Comprar más',
    buyEmpty: 'Comprar vacío',
    indicator: 'Indicador',
    indicatorSettings: 'Configuración del indicador',
    balance: 'Mi saldo',
    fee: 'Tarifa de servicio',
    ruleIdError: 'Seleccione un tiempo de caducidad',
    deleteFavoriteSuccess: 'Eliminar moneda favorita exitosamente',
    addFavoriteSuccess: 'Agregar moneda favorita exitosamente',
    buyIn: 'comprar',
    sellOut: 'Vender',
    holding: 'posición de espera',
    history: 'Historia',
    spotOrderConfirm: {
      title: 'Confirmar compra',
      amountPlaceholder: 'Por favor ingrese la cantidad de compra'
    },
    spotTradeOrder: {
      holding: {
        coin: 'moneda',
        buyInAmountPrice: 'Cantidad/Precio de compra',
        buyInCount: 'Cantidad',
        actions: 'Operación',
        sellOut: 'Vender',
        profit: 'Ganancia'
      }
    },
    orderConfirm: {
      title: 'Confirmación de pedido',
      coinName: 'Moneda',
      direction: 'Dirección',
      price: 'Precio',
      balance: 'Saldo',
      fee: 'Tarifa de servicio',
      buyMoreLabel: 'Comprar más',
      buyEmptyLabel: 'Comprar vacío',
      buyQuantity: 'Comprar cantidad',
      buyAmount: 'Importe de la compra',
      submit: 'Confirmar pedido'
    },
    kline: {
      open: 'abierto:',
      close: 'cerca:',
      change: 'scambia:'
    }
  },
  finance: {
    title: 'Finanzas'
  },
  allFinance: {
    title: 'Gestión financiera',
    all: 'todo'
  },
  financeOrders: {
    title: 'Orden de compromiso',
    holdingLabel: 'sosteniendo',
    historyLabel: 'Historia',
    holding: {
      amount: 'Cantidad de compromiso',
      rateStr: 'cantidad de ingresos/rendimiento',
      vcCount: 'Número de monedas comprometidas',
      cycle: 'Ciclo de posición',
      day: 'día',
      calcStartDate: 'Fecha de valor de inicio',
      serviceAmount: 'Tarifa de servicio',
      redeemOrder: 'Canjear'
    },
    history: {
      incomeAmount: 'cantidad de ingresos',
      rateStr: 'rendimiento',
      amount: 'Cantidad de compromiso',
      vcCount: 'Número de monedas comprometidas',
      calcStartDate: 'Fecha de valor de inicio',
      calcEndDate: 'Fecha de finalización',
      cycle: 'días de ciclo',
      serviceAmount: 'Tarifa de servicio',
      day: 'día'
    }
  },
  financeOrderBills: {
    title: 'Ley de ingresos de promesa',
    amount: 'cantidad',
    balance: 'saldo'
  },
  financeItem: {
    rateStr: 'rendimiento',
    buyType: 'Tipo de compra',
    cycle: 'días de ciclo',
    exchangeRate: 'Tipo de cambio (saldo de cambio de moneda virtual)',
    day: 'día',
    cycleType: 'tipo de ciclo',
    serviceRateStr: 'Tarifa de servicio'
  },
  buyFinance: {
    title: 'Comprar',
    rateStr: 'rendimiento',
    name: 'nombre',
    buyType: 'Tipo de compra',
    cycle: 'días de ciclo',
    cycleType: 'tipo de ciclo',
    exchangeRate: 'Tipo de cambio (saldo de cambio de moneda virtual)',
    serviceRateStr: 'Tarifa de servicio',
    remark: 'observación',
    buyAmountLabel: 'Cantidad de compra ({moneda})',
    descriptionTitle: 'Descripción del producto',
    descriptionPart1: '1. Este producto es un producto de gestión patrimonial sin garantía de principal. Las fluctuaciones del mercado pueden generar pérdidas de principal. Invierta con cuidado.',
    descriptionPart2: '2. Reglas de liquidación de pagos:',
    descriptionPart3: 'Si el precio de liquidación < precio vinculado, BTC se liquidará después del vencimiento; monto de liquidación = monto de inversión * (1+ días * tasa de rendimiento anualizada / 365).',
    descriptionPart4: 'Si el precio de liquidación ≥ precio vinculado, USDT se liquidará después del vencimiento; monto de liquidación = monto de inversión * precio vinculado * (1+ días * tasa de rendimiento anualizada / 365).',
    descriptionPart5: '3. La tasa de rendimiento anualizada real cambia con el mercado en tiempo real, consulte la transacción de compra real.',
    descriptionPart6: '4. El monto de la inversión se convierte de acuerdo con el mercado en tiempo real, consulte la transacción de compra real.',
    descriptionPart7: '5. Después de comprar el producto, se puede ver en mi página de retención de moneda y el reembolso se emitirá automáticamente a la cuenta al contado después de la fecha de vencimiento.',
    buyButton: 'Comprar [{coin}]'
  },
  fund: {
    description: 'Activos',
    recharge: 'Recargar',
    withdraw: 'Retirar',
    exchange: 'Transferir',
    empty: 'La billetera está vacía, ve'
  },
  userCenter: {
    lastLogin: 'Último inicio de sesión',
    myTeam: 'Mi Equipo',
    identity: 'Autenticación',
    walletAddress: 'Dirección de la billetera',
    zskAccount: 'Cuenta ZSK',
    bankCard: 'Cuenta bancaria',
    userBills: 'Facturas de usuario',
    timingTradeOrder: 'Tiempo de orden comercial',
    spotTradeOrder: 'Posisi berjangka',
    contactTradeOrder: 'Posición del contrato',
    userReport: 'Informe de usuario',
    teamReport: 'Informe del equipo',
    share: 'Comparte',
    customer: 'Servicio al cliente',
    helpCenter: 'Centro de ayuda',
    platform: 'Introducción a la plataforma',
    profit: 'Beneficio',
    balance: 'Saldo',
    withdraw: 'Retirar',
    recharge: 'Recargar',
    creditStoreLabel: 'Tienda de crédito'
  },
  settings: {
    title: 'Configuración',
    fundPassword: 'Contraseña del fondo',
    googleValidator: 'Google Validador',
    editLoginPassword: 'Editar contraseña de inicio de sesión',
    switchLocale: 'Cambiar idioma'
  },
  editFundPassword: {
    title: 'Cambiar contraseña del fondo',
    currentPasswordLabel: 'contraseña actual',
    currentPasswordPlaceholder: 'Ingrese la contraseña actual del fondo',
    newPasswordLabel: 'Nueva contraseña',
    newPasswordPlaceholder: 'Ingrese la contraseña del fondo modificada',
    prePasswordLabel: 'Confirmar contraseña',
    prePasswordPlaceholder: 'Borrar y volver a ingresar la contraseña del fondo modificada',
    tips: 'La contraseña del fondo es un certificado importante para las transacciones, configúrela con cuidado y téngala en cuenta',
    currentPasswordRequired: 'Ingrese la contraseña actual del fondo',
    newPasswordRequired: 'Ingrese la contraseña del fondo a modificar',
    prePasswordRequired: 'Ingrese la contraseña del fondo para modificarla nuevamente',
    prePasswordDiff: 'Dos entradas de contraseña son inconsistentes'
  },
  bindFundPassword: {
    title: 'Contraseña de enlace de fondo',
    fundPasswordLabel: 'Contraseña del fondo',
    fundPasswordPlaceholder: 'Ingrese la contraseña del fondo',
    fundPasswordPreLabel: 'Confirmar contraseña',
    fundPasswordPrePlaceholder: 'Ingrese la contraseña del fondo nuevamente',
    fundPasswordRequired: 'Se requiere la contraseña del fondo',
    fundPasswordPreRequired: 'Se requiere confirmar contraseña',
    fundPasswordDiff: 'Dos entradas de contraseña son inconsistentes',
    bindSuccess: 'Enlace exitoso',
    tips: 'La contraseña del fondo es un certificado importante para las transacciones, configúrela con cuidado y téngala en cuenta'
  },
  editLoginPassword: {
    title: 'Cambiar contraseña de inicio de sesión',
    currentPasswordLabel: 'Contraseña actual',
    currentPasswordPlaceholder: 'Ingrese la contraseña de inicio de sesión actual',
    newPasswordLabel: 'Nueva contraseña',
    newPasswordPlaceholder: 'Ingrese la contraseña de inicio de sesión modificada',
    prePasswordLabel: 'Confirmar contraseña',
    prePasswordPlaceholder: 'Borrar y volver a ingresar la contraseña de inicio de sesión modificada',
    tips: 'La contraseña de inicio de sesión es una credencial importante para la autenticación de inicio de sesión, etc., configúrela con cuidado y téngala en cuenta',
    currentPasswordRequired: 'Ingrese la contraseña de inicio de sesión actual',
    newPasswordRequired: 'Ingrese la contraseña de inicio de sesión para modificarla',
    prePasswordRequired: 'Por favor, vuelva a introducir la contraseña de inicio de sesión para modificarla',
    prePasswordDiff: 'Dos entradas de contraseña son inconsistentes'
  },
  bindGoogleValidator: {
    title: 'Vincular Google Authenticator',
    qrCodeLabel: 'código QR',
    keyLabel: 'Clave',
    loginPasswordLabel: 'Contraseña de inicio de sesión',
    loginPasswordPlaceholder: 'Ingrese su contraseña de inicio de sesión',
    googleCodeLabel: 'código de verificación de Google',
    googleCodePlaceholder: 'Ingrese un código de verificación de Google de 6 dígitos',
    tipsPart1: 'Buscar Google Authenticator en la tienda de aplicaciones',
    tipsPart2: 'Use Google Authenticator para escanear el código QR anterior, o ingrese manualmente la clave para enlazar',
    tipsPart3: 'Ingrese el código de verificación de Google de 6 dígitos anterior, haga clic en Confirmar para enviar',
    loginPasswordRequired: 'Ingrese la contraseña de inicio de sesión',
    googleCodeRequired: 'Ingrese un código de verificación de Google de 6 dígitos'
  },
  walletAddress: {
    title: 'Dirección de billetera',
    add: '+ Agregar dirección',
    remark: 'Observación',
    addButton: 'Agregar dirección de billetera',
    tips: 'Si desea modificar o eliminar la información de la dirección, comuníquese con el servicio al cliente'
  },
  addWalletAddress: {
    title: 'Agregar dirección de billetera',
    vcChainNameIdLabel: 'Tipo de cadena',
    vcAccountLabel: 'Dirección de billetera',
    vcAccountPlaceholder: 'Ingrese la dirección de la billetera',
    remarkLabel: 'Observaciones',
    remarkPlaceholder: 'Ingrese el contenido del comentario',
    fundPasswordLabel: 'Contraseña del fondo',
    fundPasswordPlaceholder: 'Ingrese la contraseña de su fondo',
    tips: 'La dirección de la billetera agregada no se puede modificar, verifique que la información sea correcta',
    vcIdRequired: 'Seleccione la moneda correcta',
    vcChainNameIdRequired: 'Seleccione el tipo de cadena correcto',
    vcAccountRequired: 'Ingrese la dirección de billetera correcta',
    fundPwdRequired: 'Ingrese la contraseña correcta del fondo',
    addSuccess: 'Dirección de billetera agregada con éxito'
  },
  receiveWays: {
    title: 'Mi tarjeta bancaria',
    add: '+ Agregar tarjeta bancaria',
    tips: 'Si desea modificar o eliminar la información de la tarjeta bancaria, comuníquese con el servicio al cliente',
    addCardButton: 'Añadir tarjeta bancaria'
  },
  zskAccount: {
    title: 'Cuenta rápida',
    add: '+ Agregar cuenta rápida',
    tips: 'Para modificar o eliminar la información de la cuenta, comuníquese con el servicio al cliente',
    addCardButton: 'Agregar cuenta'
  },
  addZskAccount: {
    title: 'Agregar una cuenta rápida',
    withdrawNameLabel: 'Nombre',
    withdrawNamePlaceholder: 'Ingrese el nombre',
    withdrawNameRequired: 'El nombre es obligatorio',
    zskLabel: 'ZSK',
    zskPlaceholder: 'Ingrese la identificación de velocidad rápida',
    fundPasswordLabel: 'Contraseña del fondo',
    fundPasswordPlaceholder: 'Ingrese la contraseña de su fondo',
    tips: 'Complete cuidadosamente la información de la cuenta agregada, la empresa no será responsable del problema de que el retiro no llegue debido a información incorrecta'
  },
  addBankCard: {
    title: 'Agregar una nueva tarjeta bancaria',
    withdrawNameLabel: 'Nombre',
    withdrawNamePlaceholder: 'Ingrese el nombre',
    withdrawNameRequired: 'El nombre es obligatorio',
    zskLabel: 'ZSK',
    zskPlaceholder: 'Ingrese el de ZSK',
    zskRequired: 'Se requiere ID de ZSK',
    cardNumLabel: 'Número de cuenta bancaria',
    cardNumPlaceholder: 'Ingrese el número de tarjeta bancaria',
    branchLabel: 'Dirección de la sucursal',
    branchPlaceholder: 'Ingrese la dirección de la sucursal de la tarjeta bancaria',
    fundPasswordLabel: 'Contraseña del fondo',
    fundPasswordPlaceholder: 'Ingrese la contraseña del fondo',
    tips: 'La tarjeta bancaria es un dato importante para el retiro de efectivo de la transacción, complete con cuidado, la empresa no será responsable de ningún problema, como la falta de recepción de efectivo debido al llenado incorrecto de la información de la tarjeta. ',
    backIdRequired: 'Por favor seleccione el banco de la cuenta',
    cardNumRequired: 'Ingrese el número de tarjeta bancaria correcto',
    fundPwdRequired: 'Ingrese la contraseña correcta del fondo',
    idCardPlaceholder: 'Ingrese su número de identificación',
    idCardLabel: 'Número de tarjeta de identificación',
    idCardRequired: 'Ingrese el número de identificación correcto',
    cciPlaceholder: 'Por favor, introduzca la tarjeta bancaria CCI',
    branchCodePlaceholder: 'Por favor ingrese el código de sucursal',
    branchCodeLabel: 'código de sucursal',
    katakanaPlaceholder: 'Por favor introduce katakana',
    katakanaLabel: 'Katakana'
  },
  userBills: {
    title: 'Registro de cambio de cuenta',
    vcName: 'Moneda',
    amount: 'Cantidad',
    balance: 'Saldo'
  },
  timingTradeOrder: {
    title: 'Tiempo de orden comercial',
    waiting: {
      title: 'Pedidos en curso',
      amount: 'Cantidad',
      period: 'período',
      receivePrice: 'Precio de compra',
      settlement: 'liquidación en curso'
    },
    history: {
      title: 'Órdenes históricas',
      buyInClose: 'Precio de compra',
      saleOutClose: 'precio de venta'
    }
  },
  spotTradeOrder: {
    title: '期货交易订单',
    waiting: {
      title: '在持订单',
      buyInAmount: '买入总价',
      buyInPrice: '买入单价',
      buyInCount: '买入数量',
      buyInTime: '买入时间'
    },
    history: {
      title: '历史订单',
      buyInAmount: '买入总价',
      buyInPrice: '买入单价',
      buyInCount: '买入数量',
      sellOutAmount: '卖出总价',
      sellOutPrice: '卖出单价',
      sellOutTime: '卖出时间'
    }
  },
  userReport: {
    title: 'Informe de usuario',
    profit: 'Beneficio',
    timingTradeAmountFee: 'Orden comercial extremadamente rápida/tarifa de manejo',
    timingTradePrizePoint: 'Bono/reembolso de negociación extremadamente rápido',
    rechargeInfo: 'Tarifa de recarga/manejo',
    withdrawInfo: 'Tarifa de retiro/manejo',
    exchangeInfo: 'Tarifa de cambio/manejo'
  },
  userReportDay: {
    title: 'Informe diario del usuario',
    profit: 'Beneficio',
    timingTradeAmountFee: 'Orden comercial extremadamente rápida/tarifa de manejo',
    timingTradePrizePoint: 'Bono/reembolso de negociación extremadamente rápido',
    rechargeInfo: 'Tarifa de recarga/manejo',
    withdrawInfo: 'Tarifa de retiro/manejo',
    exchangeInfo: 'Tarifa de cambio/manejo'
  },
  teamReport: {
    goToReportDay: 'Día del informe',
    timingTradeBetAmountServiceCharge: 'Tiempo de cantidad/servicios comerciales',
    timingTradeBetPrizePoint: 'Punto/Premio comercial de sincronización',
    timingTradeUserAndCount: 'Cronometraje de usuarios comerciales/recuentos',
    rechargeAmountFee: 'Cantidad de recarga/Servicios',
    rechargePersonCount: 'Recargar Usuarios/Cuentas',
    withdrawAmountFee: 'Retirar Monto/Servicios',
    withdrawPersonCount: 'Retirar Usuarios/Cuentas',
    firstRechargeUserAndCount: 'Cantidad/recuentos de la primera recarga',
    title: 'Informe del equipo',
    usernamePlaceholder: 'Ingrese el nombre de usuario de nivel inferior',
    previewAllTradeInfo: 'Ver toda la información comercial rápida',
    coin: 'moneda',
    timingTradeBetAmount: 'Cantidad de apuestas comerciales extremadamente rápida',
    profit: 'Beneficio',
    action: 'operación',
    previewReportDay: 'Ver el informe diario'
  },
  teamTimingTradeInfo: {
    title: 'Trading de velocidad de equipo',
    profit: 'Beneficio',
    subTitle: 'Información de transacción de velocidad del equipo',
    timingTradeAmountFee: 'Orden comercial/tarifa de servicio extremadamente rápida',
    timingTradePrizePoint: 'Bono/reembolso de negociación extremadamente rápido',
    rechargeInfo: 'Recarga/Tarifa de servicio',
    withdrawInfo: 'Tarifa de retiro/servicio',
    exchangeInfo: 'Tarifa de cambio/servicio'
  },
  teamReportDay: {
    title: 'Informe diario del equipo',
    subTitle: 'Informe diario del equipo [ {username} ]',
    timingTradeBetAmountFee: 'Tarifa de servicio/orden comercial extremadamente rápida',
    timingTradeUserAndCount: 'Cronometraje de usuarios comerciales/recuentos',
    timingTradeBetPrizePoint: 'Bono/reembolso rápido',
    rechargeAmountFee: 'Cantidad de recarga/tarifa de servicio',
    rechargePersonCount: 'Persona de recarga/número de transacciones',
    firstRechargePersonCount: 'Cantidad/recuentos de la primera recarga',
    withdrawAmountFee: 'Cantidad de retiro/tarifa de servicio',
    withdrawPersonCount: 'El número de personas que retiran dinero/transacciones',
    exchangeAmountFee: 'Cantidad de intercambio/Tarifa de servicio'
  },
  share: {
    title: 'Compartir',
    qrCodeLabel: 'código QR',
    registerUrlLabel: 'Dirección de registro',
    inviteCodeLabel: 'Código de invitación',
    hasNoInviteCode: 'La cuenta actual no tiene código de invitación',
    generateInvitationCode: 'Intentar generar con un clic',
    tipsPart1: 'Escanee el código QR anterior para completar la información de registro para registrarse',
    tipsPart2: 'Copie la dirección de registro y complete la información de registro para registrarse',
    tipsPart3: 'Abra manualmente la interfaz de registro de este sitio y complete el código de invitación para registrarse',
    saveImageError: 'No se pudo guardar la imagen, intente mantener presionada la imagen y guardar'
  },
  myTeam: {
    title: 'Mi equipo',
    usernamePlaceholder: 'Ingrese el nombre de usuario de nivel inferior',
    point: 'bonificación (velocidad/contrato)',
    totalBalance: 'Saldo',
    lastLoginTime: 'Hora del último inicio de sesión',
    noLoginTime: 'ninguno'
  },
  userDetail: {
    title: 'Detalle del usuario',
    username: 'Nombre de usuario',
    userType: 'Tipo de usuario',
    pointPercentTiming: 'Punto de tiempo',
    pointPercentContract: 'Punto de contrato',
    registerWay: 'Método de registro',
    teamCounts: 'Número de equipo',
    teamOnline: 'equipo en línea',
    balance: 'saldo',
    registerTime: 'Hora de registro',
    onlineStatus: 'estado de inicio de sesión'
  },
  addUser: {
    title: 'Agregar usuario',
    addUserDirect: {
      userTypeLabel: 'Tipo de usuario',
      usernameLabel: 'Nombre de usuario',
      usernamePlaceholder: 'Ingrese el nombre de usuario de la cuenta',
      pointTimingLabel: 'Reembolso de transacción extremadamente rápido',
      pointContractLabel: 'Reembolso de transacción de contrato',
      tips: 'La contraseña inicial es: "{contraseña}"; recuerde al usuario que cambie la contraseña a tiempo después de abrir la cuenta',
      userTypeRequired: 'Seleccione el tipo de cuenta',
      usernameRequired: 'Ingrese el nombre de usuario de la cuenta',
      pointTimingRequired: 'Seleccione el reembolso de transacción rápida',
      pointContractRequired: 'Por favor, seleccione reembolso de transacción de contrato',
      copyTemplate: `
          Nombre de usuario: {nombre de usuario};
          Contraseña de inicio de sesión: {contraseña de inicio de sesión};
          URL de inicio de sesión: {dirección de inicio de sesión};
          Reembolso de comercio rápido: {timingTradePoint};
          Reembolso de negociación de contratos: {contactTradePoint};
          `
    }
  },
  recharge: {
    title: 'Recargar',
    configIdLabel: 'Canal de recarga',
    chainNameLabel: 'Nombre de la cadena',
    amountLabel: 'Cantidad del depósito',
    userCardNameLabel: 'Pagador',
    userCardNamePlaceholder: 'Ingrese el nombre del pagador',
    fee: 'tarifa de servicio',
    receiveAmountTipsPart1: 'Recargar',
    receiveAmountTipsPart2: ', Necesita pago',
    tipsPart1: 'Debido a que la interfaz de pago en línea es inestable, ¡actualmente solo se admiten transferencias y recargas fuera de línea! ',
    tipsPart2: 'Ingrese el monto real de la transferencia con veracidad, de lo contrario, puede hacer que el sistema falle en la revisión y afecte el progreso de la recarga. ',
    emptyPart1: 'Sin canal de recarga, ',
    emptyPart2: 'Toque para volver a intentar',
    amountRequired: 'El monto de la recarga no puede estar vacío',
    maxPrecisionError: 'El monto de la recarga puede tener hasta {amountMaxPrecision} decimales',
    payUserNameError: 'Ingrese un pagador correcto y vuelva a intentarlo',
    userMobileLabel: 'Móvil',
    userMobilePlaceholder: 'Ingrese su móvil',
    needPayLabel: 'Necesita pago',
    needPayPlaceholder: 'Ingrese Cantidad'
  },
  payDetail: {
    title: 'Transferir información',
    addressLabel: 'Dirección de depósito',
    rechargeAmount: 'Cantidad',
    bankNameLabel: 'Banco',
    branchLabel: 'Dirección de la sucursal',
    cardName: 'Nombre',
    cardNum: 'número de tarjeta',
    uploadImgLabel: 'Credenciales de pago',
    uploadImgPlaceholder: 'Haga clic para cargar la imagen del comprobante de pago',
    uploadImgRequired: 'Cargue la imagen del comprobante de pago',
    vcTransferTipsPart1: '1. Copie la dirección de depósito o escanee el código QR para depositar',
    vcTransferTipsPart2: '2. Cargue la imagen del comprobante de pago después de completar el depósito',
    vcTransferTipsPart3: 'Para mejorar la eficiencia del depósito, asegúrese de cargar una imagen clara y de alta definición del certificado, si la imagen de la información relevante no es clara, puede hacer que el sistema falle en la revisión y afecte el progreso del depósito. ',
    bankCardTips: 'Para mejorar la eficiencia del depósito de dinero, asegúrese de que el nombre del remitente y el del remitente sean los mismos; si la información relevante no coincide, puede causar que el sistema falle la revisión y afecte el progreso del depósito. ',
    bankCardTransferSuccess: 'He transferido con éxito'
  },
  rechargeOrder: {
    title: 'Orden de depósito',
    payAmount: 'Cantidad',
    receiveAmount: 'Recibir cantidad'
  },
  identity: {
    title: 'Información del nombre real',
    subTitle: 'La autenticación de nombre real incluye autenticación de información, autenticación de identidad',
    name: 'nombre',
    idType: 'Tipo de documento',
    idNum: 'número de identificación',
    demand: 'Requerir',
    informationVer: 'Verificación de información',
    idAuthentication: 'Autenticación',
    material: 'Material'
  },
  verified: {
    title: 'Verificado',
    idCardTypeLabel: 'Tipo de certificado',
    idCardFrontSideImgLabel: 'Card Front SideImgLabel',
    idCardBackSideImgLabel: 'La parte posterior de la foto de identificación',
    idCardHandSideImgLabel: 'Foto de identificación de mano',
    nameLabel: 'Nombre del documento',
    namePlaceholder: 'Ingrese su nombre de ID',
    idCardNumLabel: 'Número de tarjeta de identificación',
    idCardNumPlaceholder: 'Ingrese el número de identificación',
    fundPwdLabel: 'Contraseña del fondo',
    fundPwdPlaceholder: 'Ingrese la contraseña de su fondo',
    tips: 'Una vez que se envía la autenticación de la información, no se puede modificar, verifíquela cuidadosamente y complétela correctamente',
    idCardTypeRequired: 'Seleccione el tipo de tarjeta',
    idCardFrontSideImgRequired: 'Cargue una foto frontal de la tarjeta de identificación',
    idCardBackSideImgRequired: 'Cargue una foto del reverso de la tarjeta de identificación',
    idCardHandSideImgRequired: 'Cargue una foto de identificación de mano',
    nameRequired: 'Ingrese el nombre del documento',
    idCardNumRequired: 'Ingrese el número de identificación',
    fundPwdRequired: 'Ingrese la contraseña de su fondo',
    submitSuccess: 'Solicitud de autenticación enviada con éxito'
  },
  help: {
    title: 'Centro de ayuda'
  },
  helpDetail: {
    title: 'Detalles de ayuda'
  },
  myMessage: {
    title: 'Mi mensaje'
  },
  messageDetail: {
    title: 'Detalles del mensaje'
  },
  withdraw: {
    title: 'Retirar monedas',
    tips: 'Con el fin de garantizar la seguridad de los fondos y la eficiencia de la retirada; compruebe cuidadosamente que la información completada sea correcta, la tarifa de servicios generada durante el proceso de retiro se deducirá del saldo',
    receiveAmountTipsPart1: 'Retirar',
    receiveAmountTipsPart2: ', se espera que llegue',
    fee: 'Tarifa de servicio',
    myBalance: 'Mi [{vcName}] saldo:',
    configIdLabel: 'Canal de retiro',
    amountLabel: 'Cantidad de retiro',
    fundLabel: 'Contraseña del fondo',
    fundPlaceholder: 'Ingrese la contraseña de su fondo',
    googleCodeLabel: 'código de verificación de Google',
    googleCodePlaceholder: 'Ingrese un código de verificación de Google de 6 dígitos',
    maxPrecisionError: 'El monto del retiro puede tener hasta {amountMaxPrecision} decimales',
    amountRequired: 'Ingrese o seleccione la cantidad de retiro correcta',
    bankCardError: 'Seleccione la tarjeta bancaria correcta',
    fundPwdError: 'Ingrese la contraseña correcta del fondo',
    walletAddressError: 'Seleccione la dirección de billetera correcta',
    success: 'La solicitud de retiro se envió con éxito, espere a que se procese',
    emptyPart1: 'No hay canal de retiro disponible, ',
    emptyPart2: 'Toque para reintentar'
  },
  withdrawOrder: {
    title: 'Orden de retiro',
    requestAmount: 'Cantidad',
    receiveAmount: 'Recibir cantidad'
  },
  locales: {
    title: 'Cambiar idioma'
  },
  lines: {
    title: 'Líneas',
    switchLine: 'Cambiar Línea'
  },
  currencyPop: {
    deleteFavoriteSuccess: 'Eliminar moneda favorita exitosamente',
    addFavoriteSuccess: 'Agregar moneda favorita exitosamente'
  },
  currencySelect: {
    currencyName: 'moneda',
    currencyPlaceholder: 'Haga clic para seleccionar la moneda'
  },
  walletItem: {
    available: 'disponible',
    convert: 'convertir (USDT)'
  },
  banks: {
    bankIdLabel: 'Banco',
    bankIdPlaceholder: 'Haga clic para seleccionar un banco'
  },
  banksPop: {
    title: 'Seleccionar banco',
    search: 'Palabras clave del banco de entrada'
  },
  historyOrderDetail: {
    title: 'Detalles del pedido',
    coin: 'Moneda de transacción',
    amount: 'monto del pedido',
    buyInClose: 'Precio de compra',
    sellOutClose: 'Precio de venta',
    isQuest: '¿Tiene alguna pregunta sobre este pedido?',
    connectCustomer: '¿Contactar con el servicio de atención al cliente?'
  },
  pointSelect: {
    prizeGroupPlaceholder: 'Haga clic para seleccionar el reembolso del usuario'
  },
  walletAddressSelect: {
    title: 'Seleccione la dirección de la billetera',
    label: 'Dirección de billetera',
    placeholder: 'Haga clic para seleccionar la dirección de la billetera'
  },
  myCardSelect: {
    title: 'Seleccionar cuenta',
    label: 'cuenta receptora',
    placeholder: 'Haga clic para seleccionar una cuenta'
  },
  amountInput: {
    amountRange: 'Min {minAmount}, Max {maxAmount}',
    amountMin: 'Min {minAmount}, Sin tope',
    amountErrorEmpty: 'Se requiere {etiqueta}',
    amountErrorOutRange: '{label} está fuera de rango'
  },
  amountFormItem: {
    placeholderOnlyMin: 'Min {minAmount}, Uncapped',
    placeholderHasMax: 'Min {minAmount}, Max {maxAmount}',
    amountErrorEmpty: 'La cantidad es incorrecta',
    amountErrorOutRange: 'La cantidad está fuera de rango'
  },
  common: {
    remark: 'Observación',
    saveImage: 'Guardar imagen',
    online: 'En línea',
    offline: 'Fuera de línea',
    profit: 'Beneficio',
    date: 'Fecha',
    period: 'Período',
    pointAmount: 'Cantidad de Puntos',
    point: 'Reembolso de usuario',
    direction: 'Dirección',
    winLoss: 'Ingreso',
    lose: 'Perder',
    add: 'Agregar',
    win: 'ganar',
    edit: 'Modificar',
    notBind: 'Sin consolidar',
    alreadyBind: 'Ya encuadernado',
    enabled: 'Habilitado',
    notEnabled: 'No Habilitado',
    queryRange: 'Rango de consulta',
    copy: 'Copiar',
    orderNum: 'Pedido',
    null: 'Nulo',
    noData: 'Sin datos',
    refreshSuccess: 'Actualización exitosa',
    loadMoreData: 'Cargar más datos',
    noMoreData: 'No más datos',
    lookMore: 'Más',
    more: 'Más'
  },
  date: {
    today: 'Hoy',
    yesterday: 'Ayer',
    last7Days: 'Cerca de 7 días',
    last14Days: 'Cerca de 14 días',
    split: 'A'
  },
  button: {
    save: 'Guardar',
    logout: 'Cerrar sesión',
    confirm: 'OK',
    cancel: 'Cancelar',
    submit: 'enviar',
    addNow: 'Agregar ahora',
    reset: 'restablecer',
    nextStep: 'Siguiente',
    goCertification: 'Ir a la certificación'
  },
  confirm: {
    title: {
      logout: 'Cerrar sesión',
      unBindFundPassword: 'Contraseña de fondo sin vincular',
      addUserDirect: 'Agregar Usuario',
      addUserInfo: 'Agregar usuario con éxito',
      jumpToRechargePage: 'Confirmar salto',
      unAuthentication: 'Unauthentication',
      noBindBankCard: 'Sin tarjeta bancaria',
      noBindCoinAddress: 'Sin dirección de billetera',
      tradeConfirm: 'Confirmar transacción',
      sellOutSpotOrder: 'Posición para vender',
      buyFinance: 'Confirmar compra',
      redeemOrder: 'Redención de órdenes de prenda'
    },
    content: {
      logout: '¿Estás seguro de cerrar sesión en la cuenta actual?',
      unBindFundPassword: 'Se ha detectado una contraseña de fondo no vinculada, para garantizar la seguridad de la cuenta, vincule primero la contraseña de su fondo',
      addUserDirect: 'Pronto se agregará un nuevo usuario, verifique que la información sea correcta y haga clic en Aceptar para continuar, nombre de usuario [ {username} ], tipo de usuario [ {userType} ], contraseña de inicio de sesión [ {password} ] y diferencia entre mi reembolso de velocidad comercial [ {diffPointTiming} ] y mi diferencia de reembolso de transacción de contrato [ {diffPointContract} ]',
      addUserInfo: 'Nombre de usuario [{nombre de usuario}]; <br /> Contraseña de inicio de sesión [ {password} ];<br /> URL de inicio de sesión [ {loginAddress} ];<br /> Reembolso de transacción extrema [ {pointPercentTiming} ];<br /> /> Reembolso de transacción de contrato [{pointPercentContract} ];',
      jumpToRechargePage: 'A punto de saltar a la interfaz de recarga de tres partes, haga clic en confirmar para continuar',
      unAuthentication: 'Se detecta que la cuenta no se ha autenticado con el nombre real. Para garantizar la circulación normal de los fondos, realice primero la autenticación con el nombre real',
      noBindBankCard: 'Se detecta que la cuenta no está vinculada o activada con tarjeta bancaria. Para garantizar la circulación normal de los fondos, vincule primero la tarjeta bancaria',
      noBindCoinAddress: 'Se detecta que la cuenta no tiene una cuenta de moneda virtual vinculada o habilitada. Para garantizar la circulación normal de los fondos, agregue primero la dirección de la cuenta de moneda virtual',
      tradeConfirm: 'El pedido está a punto de enviarse, verifique que la información del pedido sea correcta y haga clic en Confirmar pedido para enviarlo',
      sellOutSpotOrder: 'La orden de posición está a punto de venderse, confirme que la operación es correcta y haga clic en Aceptar para continuar',
      buyFinance: 'A punto de comprar [{coin}], compre acción: {cantidad}, confirme que la operación es correcta y haga clic en Aceptar para continuar',
      redeemOrder: 'El pedido de compromiso ({orderNum}) está a punto de ser canjeado, confirme que la operación es correcta y haga clic en Confirmar para continuar'
    }
  },
  message: {
    bindSuccess: 'Enlazar con éxito',
    successOperation: 'Operación exitosa',
    logoutSuccess: 'Salir con éxito',
    editSuccess: 'Modificado con éxito',
    addSuccess: 'Agregar exitosamente',
    copySuccess: 'Copia exitosa',
    copyFailed: 'Copia fallida'
  },
  vux: {
    'inline-calendar': {
      week_day_0: 'Día',
      week_dia_1: 'Uno',
      week_dia_2: 'dos',
      week_day_3: 'tres',
      week_day_4: 'cuatro',
      week_day_5: 'cinco',
      week_day_6: 'Seis'
    },
    loading: {
      loading: 'cargando'
    }
  },
  helpItems: {
    title: {
      part1: '¿Por qué cambia la cantidad convertida en activos? ',
      part2: 'Olvidar el método de manejo de la contraseña del fondo para transacciones OTC',
      parte3: '¿Hacia dónde fluirán los fondos después de que se complete la compra de la transacción OTC? ',
      part4: '¿Por qué quieres limitar el número de veces que puedes modificar tu apodo?',
      part5: '¿Cuál es el significado de la transferencia, por qué es necesario transferir',
      part6: '¿Cómo calcular el patrimonio de la cuenta del contrato de usuario? ',
      part7: '¿Cuál es el valor del stop loss y take profit establecido en la posición de apertura? ¿Cómo debe configurarse? ',
      parte8: '¿Cómo reducir el riesgo del contrato? ',
      part9: '¿Qué indica la cantidad en la posición abierta del contrato? ',
      part10: 'Instrucciones sobre liquidación forzosa',
      part11: '¿Cuáles son las reglas de negociación de contratos? ',
      part12: '¿Cuál es el margen en el comercio de contratos? ',
      part13: '¿Qué es la orden limitada y la orden de mercado? ',
      part14: '¿Qué representa el riesgo de las transacciones de contrato?',
      part15: '¿Por qué necesita la conversión de divisas? ',
      part16: '¿Por qué la otra parte no recibió la transferencia a tiempo después de la transferencia de la transacción OTC? ',
      part17: '¿Cómo comprar Tether (USDT) a través de OTC? '
    },
    content: {
      parte1: 'El valor de la moneda digital actualmente en renminbi cuando se convierte en activos cambiará debido a las fluctuaciones de precios de los activos digitales. El número de sus activos digitales no ha cambiado. ',
      parte2: 'Si olvida la contraseña del fondo de transacciones OTC, vaya a "Mi-Configuración-Haga clic para establecer la contraseña del fondo" o comuníquese con el servicio al cliente para restablecer',
      part3: 'Después de que se complete la orden de compra OTC, los fondos ingresarán a la cuenta en moneda legal en el activo. Si necesita utilizar activos adquiridos OTC para la negociación de contratos o la negociación de futuros, vaya al módulo de transferencia de fondos para realizar la transferencia. ',
      part4: 'Por razones de seguridad de su transacción, actualmente limitamos el apodo para que se modifique solo una vez. ',
      part5: 'Con el fin de garantizar la independencia de los fondos entre sus diversas cuentas y facilitar su control razonable de riesgos, las cuentas de los principales módulos comerciales se dividen por la presente. La transferencia se refiere al proceso de conversión mutua de activos entre varias cuentas comerciales. ',
      part6: '<p>Patrimonio de la cuenta del contrato, el método de cálculo es el siguiente:</p> <p>Patrimonio de la cuenta del contrato = margen de la posición + pérdidas y ganancias flotantes de la posición + cantidad disponible en la cuenta corriente</p>',
      part7: 'Take Profit y Stop Loss son el límite de ganancias y el límite de pérdidas establecidos por usted. Cuando se alcanza la cantidad establecida de stop loss y stop profit, el sistema cerrará automáticamente la posición. Se puede utilizar para su control de riesgos al comprar contratos. La mitad de la cantidad de toma de ganancias establecida es: aumentar la cantidad x la cantidad x el múltiplo de apalancamiento y establecer el stop loss. Le recomendamos que lo configure de acuerdo con su situación real de activos para controlar razonablemente los riesgos. ',
      part8: 'Puede transferir los activos disponibles de las cuentas restantes a la cuenta del contrato mediante la transferencia de fondos, o reducir el riesgo mediante la reducción de la posición. ',
      part9: 'La cantidad en la posición abierta indica la cantidad de moneda que espera comprar. Por ejemplo: en la página de apertura del par comercial BTC/USDT, elija comprar en largo, ingrese el precio como 1000USDT e ingrese la cantidad como 10BTC, lo que significa que espera comprar 10 BTC con un precio unitario de 1000USDT. ',
      part10: '<p>El grado de riesgo es un indicador para medir el riesgo de sus activos. Cuando el grado de riesgo es igual al 100%, su posición se considera liquidada. El grado de riesgo=(margen de la posición/patrimonio de la cuenta del contrato)*100%, para evitar que los usuarios sobrepasen sus posiciones, el sistema establece la relación de ajuste del grado de riesgo. Cuando el grado de riesgo alcance el valor de riesgo establecido por el sistema, el sistema forzará la liquidación. Por ejemplo: si el índice de ajuste establecido por el sistema es del 10%, entonces cuando su grado de riesgo sea mayor o igual al 90%, todas sus posiciones serán cerradas a la fuerza por el sistema. </p> <p>Nota: si el sistema fuerza la liquidación causada por un riesgo excesivo, todas sus posiciones se cerrarán, por lo que espero que pueda controlar razonablemente su riesgo para evitar pérdidas innecesarias</p>',
      part11: '<p>Tipo de operación</p> <p>El tipo de operación se divide en dos direcciones: posición larga abierta (compra) y posición corta abierta (venta):</p> <p>Comprar en largo (llamar) significa que cree que el índice actual puede subir y espera comprar una cierta cantidad de ciertos contratos al precio que usted establece o al precio de mercado actual. </p> <p>Venta corta (bajista) significa que usted cree que el índice actual puede caer y espera vender una cierta cantidad de ciertos contratos al precio que estableció o al precio de mercado actual. </p> <p>Cómo realizar un pedido</p> <p>Pedido límite: debe especificar el precio y la cantidad del pedido</p> <p>Pedido de mercado: solo debe establecer la cantidad de la orden, el precio es el precio de mercado actual</p> <p>Posición</p> <p>Cuando se completa la orden de apertura que envía, se llama posición</p> <p>Problemas de entrega del contrato </p> < p>El contrato de plataforma es un contrato perpetuo sin tiempo de entrega establecido. Mientras no se cumplan las condiciones de liquidación del sistema o no cierre la posición manualmente, puede mantener la posición de forma permanente. </p> <p>El sistema cierra la posición</p> <p>1: El sistema cierra automáticamente la posición cuando se alcanza el valor establecido de stop loss y stop profit</p> <p>2: El riesgo es demasiado alto, el sistema fuerza el cierre de la posición< /p>',
      parte12: '<p>En la transacción del contrato, el usuario puede participar en la transacción del contrato mediante el pago de fondos como garantía financiera para la ejecución del contrato de acuerdo con el precio y la cantidad del contrato, de acuerdo con el múltiplo de apalancamiento correspondiente, y este fondo es el margen del contrato. El usuario ocupará el margen al abrir una posición, y cuanto más se ocupe el margen para abrir una posición, mayor será el riesgo de la cuenta. </p> <p>Margen = (precio de apertura * cantidad) / ratio de apalancamiento</p>',
      part13: 'La orden limitada se refiere al precio que espera confiar a la plataforma para realizar transacciones, y la orden de mercado se refiere a confiar directamente a la plataforma para realizar transacciones al precio actual. En las reglas de apertura de posiciones, las órdenes de mercado tienen prioridad sobre las órdenes limitadas. Si elige una orden de límite, abra una posición razonablemente de acuerdo con el precio de mercado de la moneda actual para evitar pérdidas causadas por precios de apertura irrazonables. ',
      part14: 'El nivel de riesgo es el indicador de riesgo en su cuenta de contrato, y el nivel de riesgo igual al 100% se considera liquidación. Le sugerimos que, cuando su riesgo supere el 50%, debe abrir posiciones con cuidado para evitar pérdidas por liquidación. Puede reducir su riesgo reponiendo los fondos disponibles de los activos del contrato o reduciendo posiciones. ',
      part15: 'La función del intercambio es permitir la circulación fluida de fondos en diferentes monedas en sus activos, y el QCC obtenido en la cuenta de futuros se puede convertir libremente en USDT para negociar. USDT en otras cuentas también se puede convertir libremente en QCC para transacciones. ',
      part16: 'En primer lugar, asegúrese de que el método de pago que complete al transferir dinero sea exactamente el mismo que se muestra en la página de detalles del pedido. Luego, confirme si su método de pago es instantáneo o diferido. Finalmente, comuníquese con su banco e institución de pago para el mantenimiento del sistema u otras razones. ',
      part17: '<p>Método 1: seleccione el pedido que desea comprar a través de la lista de compra y venta OTC para comprar o vender. </p> <p>Método 2: haga clic en el botón publicar para publicar órdenes de compra o venta de acuerdo con sus necesidades de transacciones rápidas. El sistema lo conectará rápidamente con compradores y vendedores. </p> <p>Nota: Si la orden de compra no se paga después de 15 minutos, el sistema cancelará automáticamente la orden, pague a tiempo. Si la orden se cancela más de 3 veces el mismo día, la transacción no se puede realizar nuevamente el mismo día y la autoridad comercial se restablecerá al día siguiente. </p>'
    }
  }
}



// WEBPACK FOOTER //
// ./src/locales/es.js